import React from 'react';
import PropTypes from 'prop-types';

const FileArchiverCompleteState = ({ url }) => <React.Fragment>
  If the download did not start automatically, <a href={url}>click here</a>.
</React.Fragment>;

FileArchiverCompleteState.propTypes = {
  url: PropTypes.string.isRequired
};

export default FileArchiverCompleteState;
